import { Injectable } from '@angular/core';
import { PersonalInfoConfig } from '../interface/personal-info-config.interface';

@Injectable()
export class PersonalInfoConfigService {
    constructor(
    ) { }

    /**
        * @description this method will get the config settings for combo packs page
        * @date 2019-09-16
        * @memberof ProductDetailConfigSettings
        */
    public getSettings(countryCode: string): PersonalInfoConfig {
        let personalInfoConfig: PersonalInfoConfig;
        switch (countryCode.toUpperCase()) {
            case 'USA':
                personalInfoConfig = this.loadUSASettings();
                break;
            case 'CAN':
                personalInfoConfig = this.loadCANSettings();
                break;
            case 'GBR':
                personalInfoConfig = this.loadGBRSettings();
                break;
            case 'ARE':
                personalInfoConfig = this.loadARESettings();
                break;
            case 'SAU':
                personalInfoConfig = this.loadSAUSettings();
                break;
            case 'QAT':
                personalInfoConfig = this.loadQATSettings();
                break;
            case 'IRL':
                personalInfoConfig = this.loadIRLSettings();
                break;
            case 'ILN':
                personalInfoConfig = this.loadILNSettings();
                break;
            case 'KWT':
                personalInfoConfig = this.loadKWTSettings();
                break;
            case 'BHR':
                personalInfoConfig = this.loadBHRSettings();
                break;
            case 'OMN':
                personalInfoConfig = this.loadOMNSettings();
                break;
            case 'AUS':
                personalInfoConfig = this.loadAUSSettings();
                break;   
            case 'NZL':
                personalInfoConfig = this.loadNZLSettings();
                break;    
            case 'SWE':
                personalInfoConfig = this.loadSWESettings();
                break;
            case 'DNK':
                personalInfoConfig = this.loadDNKSettings();
                break;
            case 'FIN':
                personalInfoConfig = this.loadFINSettings();
                break;
            case 'NOR':
                personalInfoConfig = this.loadNORSettings();
                break; 
            case 'BEL':
                personalInfoConfig = this.loadBELSettings();
                break;    
            case 'LUX':
                personalInfoConfig = this.loadLUXSettings();
                break; 
            case 'NLD':
                personalInfoConfig = this.loadNLDSettings();
                break;
            case 'POL':
                personalInfoConfig = this.loadPOLSettings();
                break; 
            case 'BGR':
                 personalInfoConfig = this.loadBGRSettings();
                break; 
            case 'MKD':
                personalInfoConfig = this.loadMKDSettings();
                break;  
            case 'DEU':
                personalInfoConfig = this.loadDEUSettings();
                break;
            case 'AUT':
                personalInfoConfig = this.loadAUTSettings();
                break;
            case 'NGA':
                personalInfoConfig = this.loadNGASettings();
                break;  
            case 'ZAF':
                personalInfoConfig = this.loadZAFSettings();
                break;                 
            case 'CHE':
                personalInfoConfig = this.loadCHESettings();
                break;
            case 'SEN':
                personalInfoConfig = this.loadSENSettings();
                break;  
            case 'ISL':
                personalInfoConfig = this.loadISLSettings();
                break; 
            case 'TZA':
                personalInfoConfig = this.loadTZASettings();
                break;
            case 'CIV':
                personalInfoConfig = this.loadCIVSettings();
                break;             
            default:
                personalInfoConfig = this.loadUSASettings();
                break;
        }
        return personalInfoConfig;
    }

    /**
     * @description this method will return usa settings
     * @date 2019-09-19
     * @private
     * @returns {PersonalInfoConfig}
     * @memberof PersonalInfoConfigService
     */
    private loadUSASettings(): PersonalInfoConfig {
        const personalInfoConfig: PersonalInfoConfig = {
            countryCode: 'USA',
            showBonusInfoSection: false,
            enableSingleAndDirectDebit : false,
            joinTypePersanalInfoSchemaForm: false,
            enableDOBForFPCEnrollment: false,
            identificationType: 'SSN',
            removeVatId: false
        };
        return personalInfoConfig;
    }

    private loadNGASettings(): PersonalInfoConfig {
        const personalInfoConfig: PersonalInfoConfig = {
            countryCode: 'NGA',
            showBonusInfoSection: true,
            enableSingleAndDirectDebit : true,
            joinTypePersanalInfoSchemaForm: true,
            enableDOBForFPCEnrollment: false,
            identificationType: 'ITIN',
            removeVatId: false
        };
        return personalInfoConfig;
    }
    private loadZAFSettings(): PersonalInfoConfig {
        const personalInfoConfig: PersonalInfoConfig = {
            countryCode: 'ZAF',
            showBonusInfoSection: true,
            enableSingleAndDirectDebit : true,
            joinTypePersanalInfoSchemaForm: true,
            enableDOBForFPCEnrollment: false,
            identificationType: 'CORP-ID',
            removeVatId: false
        };
        return personalInfoConfig;
    }
    /**
     * @description this method will return CAN settings
     * @date 2019-09-19
     * @private
     * @returns {PersonalInfoConfig}
     * @memberof PersonalInfoConfigService
     */
    private loadCANSettings(): PersonalInfoConfig {
        const personalInfoConfig: PersonalInfoConfig = {
            countryCode: 'CAN',
            showBonusInfoSection: false,
            enableSingleAndDirectDebit : false,
            joinTypePersanalInfoSchemaForm: false,
            enableDOBForFPCEnrollment: false,
            identificationType: 'SIN',
            removeVatId: false
        };
        return personalInfoConfig;
    }

    /**
     * @description this method will return GBR settings
     * @date 2019-09-19
     * @private
     * @returns {PersonalInfoConfig}
     * @memberof PersonalInfoConfigService
     */
    private loadGBRSettings(): PersonalInfoConfig {
        const personalInfoConfig: PersonalInfoConfig = {
            countryCode: 'GBR',
            showBonusInfoSection: true,
            enableSingleAndDirectDebit : true,
            joinTypePersanalInfoSchemaForm: true,
            enableDOBForFPCEnrollment: false,
            bonusInfoDynamicValidation: true,
            identificationType: 'VAT ID',
            removeVatId: false,
            billingAddressMode: 'partial'
        };
        return personalInfoConfig;
    }

    /**
     * @description this method will return ARE settings
     * @date 2020-04-27
     * @private
     * @returns {PersonalInfoConfig}
     * @memberof PersonalInfoConfigService
     */
    private loadARESettings(): PersonalInfoConfig {
        const personalInfoConfig: PersonalInfoConfig = {
            countryCode: 'ARE',
            showBonusInfoSection: false,
            enableSingleAndDirectDebit : false,
            joinTypePersanalInfoSchemaForm: false,
            enableDOBForFPCEnrollment: true,
            identificationType: 'VAT ID',
            removeVatId: false
        };
        return personalInfoConfig;
    }

    /**
    * @description this method will return ARE settings
    * @date 2020-04-27
    * @private
    * @returns {PersonalInfoConfig}
    * @memberof PersonalInfoConfigService
    */
    private loadSAUSettings(): PersonalInfoConfig {
        const personalInfoConfig: PersonalInfoConfig = {
            countryCode: 'SAU',
            showBonusInfoSection: false,
            enableSingleAndDirectDebit : false,
            joinTypePersanalInfoSchemaForm: false,
            enableDOBForFPCEnrollment: true,
            identificationType: 'VAT ID',
            removeVatId: false
        };
        return personalInfoConfig;
    }
    /**
     * @description returns QAT personal info settings
     * @author njagadeesan
     * @date 2020-11-24
     * @private
     * @returns {PersonalInfoConfig}
     * @memberof PersonalInfoConfigService
     */
    private loadQATSettings(): PersonalInfoConfig {
        const personalInfoConfig: PersonalInfoConfig = {
            countryCode: 'QAT',
            showBonusInfoSection: false,
            enableSingleAndDirectDebit : false,
            joinTypePersanalInfoSchemaForm: false,
            enableDOBForFPCEnrollment: true,
            identificationType: 'VAT ID',
            removeVatId: false
        };
        return personalInfoConfig;
    }

    /**
     * @description this method will return GBR settings
     * @date 2019-09-19
     * @private
     * @returns {PersonalInfoConfig}
     * @memberof PersonalInfoConfigService
     */
    private loadIRLSettings(): PersonalInfoConfig {
        const personalInfoConfig: PersonalInfoConfig = {
            countryCode: 'IRL',
            showBonusInfoSection: true,
            enableSingleAndDirectDebit : true,
            joinTypePersanalInfoSchemaForm: true,
            enableDOBForFPCEnrollment: false,
            bonusInfoDynamicValidation: true,
            identificationType: 'VAT ID',
            removeVatId: false,
            billingAddressMode: 'partial'
        };
        return personalInfoConfig;
    }

    /**
     * @description this method will return GBR settings
     * @date 2019-09-19
     * @private
     * @returns {PersonalInfoConfig}
     * @memberof PersonalInfoConfigService
     */
    private loadILNSettings(): PersonalInfoConfig {
        const personalInfoConfig: PersonalInfoConfig = {
            countryCode: 'ILN',
            showBonusInfoSection: true,
            enableSingleAndDirectDebit : true,
            joinTypePersanalInfoSchemaForm: true,
            enableDOBForFPCEnrollment: false,
            bonusInfoDynamicValidation: true,
            identificationType: 'VAT ID',
            removeVatId: false,
            billingAddressMode: 'partial'
        };
        return personalInfoConfig;
    }


    /**
     * @description this method will return KWT settings
     * @author Akhil
     * @date 2020-12-16
     * @private
     * @returns {PersonalInfoConfig}
     * @memberof PersonalInfoConfigService
     */
    private loadKWTSettings(): PersonalInfoConfig {
        const personalInfoConfig: PersonalInfoConfig = {
            countryCode: 'KWT',
            showBonusInfoSection: false,
            enableSingleAndDirectDebit : false,
            joinTypePersanalInfoSchemaForm: false,
            enableDOBForFPCEnrollment: true,
            identificationType: 'VAT ID',
            removeVatId: false
        };
        return personalInfoConfig;
    }

    /**
     * @description this method will return BHR settings
     * @date 2021-02-11
     * @private
     * @returns {PersonalInfoConfig}
     * @memberof PersonalInfoConfigService
     */
    private loadBHRSettings(): PersonalInfoConfig {
        const personalInfoConfig: PersonalInfoConfig = {
            countryCode: 'BHR',
            showBonusInfoSection: false,
            enableSingleAndDirectDebit : false,
            joinTypePersanalInfoSchemaForm: false,
            enableDOBForFPCEnrollment: true,
            identificationType: 'VAT ID',
            removeVatId: false
        };
        return personalInfoConfig;
    }

     /**
     * @description this method will return OMN settings
     * @date 2021-03-08
     * @private
     * @returns {PersonalInfoConfig}
     * @memberof PersonalInfoConfigService
     */
    private loadOMNSettings(): PersonalInfoConfig {
        const personalInfoConfig: PersonalInfoConfig = {
            countryCode: 'OMN',
            showBonusInfoSection: false,
            enableSingleAndDirectDebit : false,
            joinTypePersanalInfoSchemaForm: false,
            enableDOBForFPCEnrollment: true,
            identificationType: 'VAT ID',
            removeVatId: false
        };
        return personalInfoConfig;
    }

    /**
     * @description this method will return AUS settings 
     * @author Akhil
     * @date 2021-03-15
     * @private
     * @returns {PersonalInfoConfig}
     * @memberof PersonalInfoConfigService
     */
    private loadAUSSettings(): PersonalInfoConfig {
        const personalInfoConfig: PersonalInfoConfig = {
            countryCode: 'AUS',
            showBonusInfoSection: true,
            enableSingleAndDirectDebit : true,
            joinTypePersanalInfoSchemaForm: false,
            enableDOBForFPCEnrollment: true,
            identificationType: 'VAT ID',
            bonusInfoPaymentOptions: true,
            removeVatId: false
        };
        return personalInfoConfig;
    }
     /**
     * @description this method will return NZL settings 

    /**
     * @description this method will return SWE settings
     * @date 2021-04-06
     * @private
     * @returns {PersonalInfoConfig}
     * @memberof PersonalInfoConfigService
     */
      private loadNZLSettings(): PersonalInfoConfig {
        const personalInfoConfig: PersonalInfoConfig = {
            countryCode: 'NZL',
            showBonusInfoSection: true,
            enableSingleAndDirectDebit : true,
            joinTypePersanalInfoSchemaForm: false,
            enableDOBForFPCEnrollment: true,
            identificationType: 'VAT ID',
            bonusInfoPaymentOptions: true,
            removeVatId: false
        }
        return personalInfoConfig;
    }
     private loadSWESettings(): PersonalInfoConfig {
        const personalInfoConfig: PersonalInfoConfig = {
            countryCode: 'SWE',
            showBonusInfoSection: true,
            enableSingleAndDirectDebit : true,
            joinTypePersanalInfoSchemaForm: false,
            enableDOBForFPCEnrollment: false,
            bonusInfoDynamicValidation: true,
            identificationType: 'VAT ID',
            removeVatId: false,
            showBonusDebitInforMenu:false
        };
        return personalInfoConfig;
    }

    /**
     * @description this method will return DNK settings
     * @date 2021-04-06
     * @private
     * @returns {PersonalInfoConfig}
     * @memberof PersonalInfoConfigService
     */
     private loadDNKSettings(): PersonalInfoConfig {
        const personalInfoConfig: PersonalInfoConfig = {
            countryCode: 'DNK',
            showBonusInfoSection: true,
            enableSingleAndDirectDebit : true,
            joinTypePersanalInfoSchemaForm: false,
            enableDOBForFPCEnrollment: false,
            bonusInfoDynamicValidation: true,
            identificationType: 'VAT ID',
            removeVatId: false,
            showBonusDebitInforMenu:false
        };
        return personalInfoConfig;
    }

    /**
     * @description this method will return NOR settings
     * @date 2021-04-06
     * @private
     * @returns {PersonalInfoConfig}
     * @memberof PersonalInfoConfigService
     */
     private loadNORSettings(): PersonalInfoConfig {
        const personalInfoConfig: PersonalInfoConfig = {
            countryCode: 'NOR',
            showBonusInfoSection: true,
            enableSingleAndDirectDebit : true,
            joinTypePersanalInfoSchemaForm: false,
            enableDOBForFPCEnrollment: false,
            bonusInfoDynamicValidation: true,
            identificationType: 'VAT ID',
            removeVatId: false,
            showBonusDebitInforMenu:false
        };
        return personalInfoConfig;
    }
    /**
     * @description this method will return FIN settings
     * @date 2021-04-06
     * @private
     * @returns {PersonalInfoConfig}
     * @memberof PersonalInfoConfigService
     */
     private loadFINSettings(): PersonalInfoConfig {
        const personalInfoConfig: PersonalInfoConfig = {
            countryCode: 'FIN',
            showBonusInfoSection: true,
            enableSingleAndDirectDebit : true,
            showBonusDebitInforMenu:false,
            joinTypePersanalInfoSchemaForm: false,
            enableDOBForFPCEnrollment: false,
            bonusInfoDynamicValidation: true,
            identificationType: 'VAT ID',
            removeVatId: false
        };
        return personalInfoConfig;
    }
      /**
     * @description this method will return usa settings
     * @date 2019-09-19
     * @private
     * @returns {PersonalInfoConfig}
     * @memberof PersonalInfoConfigService
     */
       private loadBELSettings(): PersonalInfoConfig {
        const personalInfoConfig: PersonalInfoConfig = {
            countryCode: 'BEL',
            showBonusInfoSection: true,
            enableSingleAndDirectDebit : true,
            joinTypePersanalInfoSchemaForm: false,
            enableDOBForFPCEnrollment: true,
            identificationType: 'SSN',
            displayTitle:true,
            showBonusDebitInforMenu:true,
            removeVatId: false
        };
        return personalInfoConfig;
    }

      /**
     * @description this method will return usa settings
     * @date 2019-09-19
     * @private
     * @returns {PersonalInfoConfig}
     * @memberof PersonalInfoConfigService
     */
       private loadLUXSettings(): PersonalInfoConfig {
        const personalInfoConfig: PersonalInfoConfig = {
            countryCode: 'LUX',
            showBonusInfoSection: true,
            enableSingleAndDirectDebit : true,
            joinTypePersanalInfoSchemaForm: false,
            enableDOBForFPCEnrollment: true,
            identificationType: 'SSN',
            displayTitle:true,
            showBonusDebitInforMenu:true,
            removeVatId: false
        };
        return personalInfoConfig;
    }

      /**
     * @description this method will return usa settings
     * @date 2019-09-19
     * @private
     * @returns {PersonalInfoConfig}
     * @memberof PersonalInfoConfigService
     */
       private loadNLDSettings(): PersonalInfoConfig {
        const personalInfoConfig: PersonalInfoConfig = {
            countryCode: 'NLD',
            showBonusInfoSection: true,
            enableSingleAndDirectDebit : true,
            joinTypePersanalInfoSchemaForm: false,
            enableDOBForFPCEnrollment: true,
            identificationType: 'BSN',
            displayTitle:true,
            showBonusDebitInforMenu:true,
            removeVatId: false
        };
        return personalInfoConfig;
    }

    /**
     * @description this method will return POL Settings
     * @author Akhil
     * @date 2021-05-18
     * @private
     * @returns {PersonalInfoConfig}
     * @memberof PersonalInfoConfigService
     */
    private loadPOLSettings(): PersonalInfoConfig {
        const personalInfoConfig: PersonalInfoConfig = {
            countryCode: 'POL',
            showBonusInfoSection: false,
            enableSingleAndDirectDebit : false,
            joinTypePersanalInfoSchemaForm: false,
            enableDOBForFPCEnrollment: true,
            identificationType: 'PERSONAL ID',
            personalIDValidationMgs : true,
            showBusinessInfoSection: true,
            bonusInfoDynamicValidation: true,
            removeVatId: false
        };
        return personalInfoConfig;
    }

    private loadDEUSettings(): PersonalInfoConfig {
        const personalInfoConfig: PersonalInfoConfig = {
            countryCode: 'DEU',
            showBonusInfoSection: false,
            enableSingleAndDirectDebit : true,
            joinTypePersanalInfoSchemaForm: false,
            enableDOBForFPCEnrollment: true,
            bonusInfoDynamicValidation: true,
            identificationType: 'VAT ID',
            removeVatId: true,
            displayTitle: true,
            showBonusDebitInforMenu:true,
            hideMiddleName: true,
            enableCreditAssessment : true
        };
        return personalInfoConfig;
    }
    private loadAUTSettings(): PersonalInfoConfig {
        const personalInfoConfig: PersonalInfoConfig = {
            countryCode: 'AUT',
            showBonusInfoSection: false,
            enableSingleAndDirectDebit : true,
            joinTypePersanalInfoSchemaForm: false,
            enableDOBForFPCEnrollment: true,
            bonusInfoDynamicValidation: true,
            identificationType: 'VAT ID',
            removeVatId: true,
            displayTitle: true,
            showBonusDebitInforMenu:true,
            hideMiddleName: true,
            enableCreditAssessment : true
        };
        return personalInfoConfig;
    }
     /**
     * @description this method will return BGR Settings
     * @date 2022-06-03
     * @private
     * @returns {PersonalInfoConfig}
     * @memberof PersonalInfoConfigService
     */
    private loadBGRSettings(): PersonalInfoConfig {
        const personalInfoConfig: PersonalInfoConfig = {
            countryCode: 'BGR',
            showBonusInfoSection: false,
            enableSingleAndDirectDebit : true,
            joinTypePersanalInfoSchemaForm: false,
            enableDOBForFPCEnrollment: false,
            identificationType: 'PERSONAL ID',
            showBusinessInfoSection: false,
            bonusInfoDynamicValidation: false
        };
        return personalInfoConfig;
    }
    /**
     * @description this method will return MKD Settings
     * @date 2022-06-03
     * @private
     * @returns {PersonalInfoConfig}
     * @memberof PersonalInfoConfigService
     */
    private loadMKDSettings(): PersonalInfoConfig {
        const personalInfoConfig: PersonalInfoConfig = {
            countryCode: 'MKD',
            showBonusInfoSection: false,
            enableSingleAndDirectDebit : true,
            joinTypePersanalInfoSchemaForm: false,
            enableDOBForFPCEnrollment: false,
            identificationType: 'PERSONAL ID',
            showBusinessInfoSection: false,
            bonusInfoDynamicValidation: false
        };
        return personalInfoConfig;
    }
    private loadCHESettings(): PersonalInfoConfig {
        const personalInfoConfig: PersonalInfoConfig = {
            countryCode: 'CHE',
            showBonusInfoSection: false,
            enableSingleAndDirectDebit: true,
            joinTypePersanalInfoSchemaForm: false,
            enableDOBForFPCEnrollment: true,
            bonusInfoDynamicValidation: true,
            identificationType: 'VAT ID',
            removeVatId: true,
            displayTitle: true,
            showBonusDebitInforMenu: true,
            hideMiddleName: true,
            enableCreditAssessment: true
        };
        return personalInfoConfig;
    }

    private loadSENSettings(): PersonalInfoConfig {
        const personalInfoConfig: PersonalInfoConfig = {
            countryCode: 'SEN',
            showBonusInfoSection: false,
            enableSingleAndDirectDebit: false,
            joinTypePersanalInfoSchemaForm: false,
            enableDOBForFPCEnrollment: true,
            identificationType: 'VAT ID',
            removeVatId: true,
            displayTitle: false,
            hideMiddleName: false
        };
        return personalInfoConfig;
    }
    private loadISLSettings(): PersonalInfoConfig {
        const personalInfoConfig: PersonalInfoConfig = {
            countryCode: 'ISL',
            showBonusInfoSection: true,
            enableSingleAndDirectDebit: true,
            joinTypePersanalInfoSchemaForm: true,
            enableDOBForFPCEnrollment: false,
            bonusInfoDynamicValidation: true,
            identificationType: 'KT',
            removeVatId: false,
            billingAddressMode: 'partial'
        };
        return personalInfoConfig;
    }

    private loadTZASettings(): PersonalInfoConfig {
        const personalInfoConfig: PersonalInfoConfig = {
            countryCode: 'TZA',
            showBonusInfoSection: false,
            enableSingleAndDirectDebit : false,
            joinTypePersanalInfoSchemaForm: false,
            enableDOBForFPCEnrollment: true,
            identificationType: 'VAT ID',
            removeVatId: true,
            displayTitle:false,
            hideMiddleName:false
        };
        return personalInfoConfig;
    }

    private loadCIVSettings(): PersonalInfoConfig {
        const personalInfoConfig: PersonalInfoConfig = {
            countryCode: 'CIV',
            showBonusInfoSection: true,
            enableSingleAndDirectDebit : true,
            joinTypePersanalInfoSchemaForm: true,
            enableDOBForFPCEnrollment: false,
            identificationType: 'VAT ID',
            removeVatId: false
        };
        return personalInfoConfig;
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/services/personal-info-config.service.ts